import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationUnread } from 'entities/Conversation/api/types'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventSmartViewsConversationUnread = () => {
  const entities = useEntitiesContext()
  const { smartViewsStore } = entities
  const handler = (data: IResponseConversationUnread) => {
    const conversation = new Conversation(data.conversation, entities)

    smartViewsStore.itemsList.forEach((item) => {
      if (checkFilterSmartView(conversation.smartViewFilterParams, item.filters)) {
        runInAction(() => {
          item.setUnread(item.unread + conversation.concatUnread)
        })
      }
    })
  }

  useEffect(
    () => entities.websocket.on(WebsocketEvent.ConversationUnread, handler),
    [smartViewsStore.itemsList]
  )
}
